"use client"

import { useCallback } from "react"
import { pipe } from "fp-ts/lib/function"
import * as E from "fp-ts/Either"
import { useKyoboConnectionStore } from "./useKyoboConnectionStore"
import fetchClientPurchaseSyncConsentStatus from "./fetchClientPurchaseSyncConsentStatus"

const useKyoboConnection = () => {
  const { connectionStatus, setConnectionStatus, resetConnectionStatus } =
    useKyoboConnectionStore()

  const fetch = useCallback(async () => {
    const result = await fetchClientPurchaseSyncConsentStatus()
    pipe(
      result,
      E.match(
        () => {},
        (data) => {
          if (!data || typeof data !== "object") return
          const status = (data as { status?: unknown }).status
          if (status === "CONSENTED" || status === "WITHDRAWN") {
            setConnectionStatus(status)
          }
        },
      ),
    )
  }, [setConnectionStatus])

  return {
    connectionStatus,
    fetch,
    clear: resetConnectionStatus,
  }
}

export default useKyoboConnection
